import React from 'react';
import { Star, CheckCircle, Upload, Award } from 'lucide-react';

const STEPS = [
  { icon: CheckCircle, step: '1', title: 'Complete the course', desc: 'Your manager will assign you specific courses to complete. Work through them at your own pace.' },
  { icon: Upload, step: '2', title: 'Mark as completed', desc: 'Once done, mark the course as completed in the app. Upload a screenshot of your certificate if one is provided.' },
  { icon: Award, step: '3', title: 'Manager verifies', desc: 'Your manager reviews your completion and verifies it in the system — they may check your certificate.' },
  { icon: Star, step: '4', title: 'Points awarded', desc: 'Once verified, your manager allocates the reward points to your account. Use points to claim rewards!' },
];

export default function PointsGuide() {
  return (
    <div className="my-4 border border-border rounded-xl p-4 bg-card">
      <div className="flex items-center gap-2 mb-4">
        <Star className="w-4 h-4 text-yellow-500" />
        <h3 className="text-sm font-bold text-foreground">How the Points & Rewards System Works</h3>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
        {STEPS.map(({ icon: Icon, step, title, desc }) => (
          <div key={step} className="flex gap-3 bg-muted/30 rounded-lg px-3 py-3">
            <div className="w-7 h-7 rounded-full bg-primary/15 flex items-center justify-center shrink-0">
              <Icon className="w-3.5 h-3.5 text-primary" />
            </div>
            <div>
              <p className="text-xs font-bold text-foreground">Step {step}: {title}</p>
              <p className="text-xs text-muted-foreground mt-0.5 leading-relaxed">{desc}</p>
            </div>
          </div>
        ))}
      </div>
      <div className="mt-3 bg-yellow-500/10 border border-yellow-500/20 rounded-lg px-3 py-2">
        <p className="text-xs text-yellow-700 dark:text-yellow-400">
          💡 <strong>Certificate uploads are encouraged but not always mandatory.</strong> When you receive a certificate (e.g., food hygiene, first aid), upload it to keep your training record complete.
        </p>
      </div>
    </div>
  );
}
